import React from 'react';
import { string, func, array, bool } from 'prop-types';
import { TableCustom, Modal } from '../../common';

import './index.css';
import { CloneObject } from '../../../utils/helpers';


const StaticEntidadesModal = (props) => {


  const cellS = (props) =>    <div className='action'>
                                  <div onClick={ (event) => handleClickSelect(props.value) } className="link">
                                  <span className="material-symbols-outlined" title="Seleccionar">west</span>
                                  </div>
                              </div>

  const rowSelect = { Header: '', Cell: cellS, id:'select', accessor: 'id', width: '5%', disableGlobalFilter: true, disableSortBy: true };
  const tableColumns = [rowSelect].concat(props.columns);

  //handles
  const handleClickSelect = (id) => {
    const row = props.list.find(f => f.id === id);
    props.onConfirm(id, CloneObject(row));
  }

  const handleClicWithoutSelection = () => {
    props.onConfirm(0, null);
  }


  return (
    <div className='entidad-modal'>

      <Modal
        size="lg"
        title={props.title}
        onEscape={() => props.onDismiss()}
        body={(
              <TableCustom
                  showFilterGlobal={true}
                  className={'TableCustomBase'}
                  columns={tableColumns}
                  data={props.list}
                  onClickRow={({ original }) => props.onConfirm(original.id, CloneObject(original))}
              />
        )}
        footer={(
              <div className='footer-action-container'>
                {props.showWithoutSelection &&
                <button className="btn btn-outline-primary float-end" data-dismiss="modal" onClick={ (event) => handleClicWithoutSelection() }>Sin selección</button>
                }
                <button className="btn back-button float-start" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
              </div>
        )}
      />

    </div>
  );
}

StaticEntidadesModal.propTypes = {
  title: string.isRequired,
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
  columns: array.isRequired,
  list: array.isRequired,
  showWithoutSelection: bool
};

StaticEntidadesModal.defaultProps = {
  showWithoutSelection: true
};

export default StaticEntidadesModal;
